/**
 * Asynchronously loads the component for NotFoundPage
 */

import loadable from 'ctrwowShared/utils/loadable';

export default loadable(() => import('./DashboardLayout'));
